.toggle {
	outline: none;
	cursor: pointer;
}
